// extracted by mini-css-extract-plugin
export var label = "_hn-2";
export var slideContainer = "_hn-0";
export var slider = "_hn-1";